module.exports = __webpack_public_path__ + "static/media/cross-white.0aae3e8d.svg";